module.exports = __webpack_public_path__ + "static/media/Back_5.e5315193.jpg";